<template>
  <div id="wrapper-dashboard-index">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col class="col-left col-auto" :class="{'col-left-expanded': expanded}">
          <LmColumnMenu
            :menuItems="mainMenuItems"
            @expanded="expanded=$event"
          />
        </b-col>
        <b-col class="col-right">
          <LmHeader />
          <router-view />
          <LmFooter />
        </b-col>
      </b-row>
      <b-alert
        class="fixed-top mt-2 alert"
        :show="hideCounter"
        variant="warning"
        v-if="showRequestPermissionAlert"
        >
        <span>{{ alertRequestNotificationMessage }}</span><button class="btn btn-link ml-2 p-0 border-0" @click="requestPermission(); close()">Aceptar</button>
      </b-alert>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmColumnMenu from '@/components/LmColumnMenu.vue'
import LmHeader from '@/components/LmHeader.vue'
import LmFooter from '@/components/LmFooter.vue'

export default {
  data () {
    return {
      expanded: true,
      hideCounter: 100000,
      alertRequestNotificationMessage: process.env.VUE_APP_ALERT_REQUEST_NOTIFICATION_MESSAGE
    }
  },
  components: {
    LmColumnMenu,
    LmHeader,
    LmFooter
  },
  computed: {
    ...mapState('settings', ['mainMenuItems', 'loading']),
    ...mapState('notifications', ['browserSupportFirebaseMessagin']),
    showRequestPermissionAlert () {
      if ('Notification' in window && this.browserSupportFirebaseMessagin) {
        return process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes' && Notification.permission === 'default'
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings']),
    ...mapActions('notifications', ['requestPermission']),
    close () {
      this.hideCounter = 0
    }
  },
  created () {
    this.getMainMenuSettings()
  }
}
</script>

<style lang="sass" scoped>
  .col-right
    display: flex
    flex-direction: column
    min-height: 100vh
  .col-left
    transition: flex-basis 0.2s ease
    @media(min-width: $xl)
      flex: 0 1 80px
    &.col-left-expanded
      @media(min-width: $xl)
        flex: 0 1 235px
  .alert
    left: 15px
    right: 15px
    margin: auto
    @media(min-width: $lg)
      width: 50%
      left: 265px
      right: auto
    @media(min-width: $xl)
      width: calc(100% - 640px)
</style>
